import { useEffect, useMemo, useState } from 'react'
import { useFetchRewards } from '../../userQueries'
import { getNextExpiryDelayMs, isRewardActive } from './rewardUtils'

export function useRewardsData() {
    const { data: rewards = [], isLoading } = useFetchRewards()
    const [expiryTick, setExpiryTick] = useState(0)

    useEffect(() => {
        const delayMs = getNextExpiryDelayMs(rewards)
        if (delayMs === null) return

        const timeoutId = setTimeout(() => setExpiryTick((tick) => tick + 1), delayMs)
        return () => clearTimeout(timeoutId)
    }, [rewards, expiryTick])

    const activeRewards = useMemo(() => rewards.filter(isRewardActive), [rewards])

    const totalRewards = useMemo(() => activeRewards.reduce((acc, r) => acc + r.quantityRemaining, 0), [activeRewards])

    return {
        rewards,
        activeRewards,
        isLoading,
        hasRewards: rewards.length > 0,
        totalRewards,
    }
}
